class CreateDomesticExtraReq {
    constructor() {
        this.Id = undefined;
        this.PatientId = undefined;
        this.DomesticStayId = undefined;
        this.ExtraType = undefined;
        this.ExtraDescription = undefined;
        this.ExtraPrice = undefined;
        this.ExtraPricePaid = undefined;
        this.ExtraQuantity = undefined;
        this.QuantityRecieved = undefined;
        this.ExtraTotalPrice = undefined;

 
    }
}
export default CreateDomesticExtraReq;